// Formulary API service using HATEOAS style
import { apiCall } from './apiService'

// Enums matching OpenAPI schema
export type CategoryEnum = 'peptide' | 'weight_loss' | 'hormone' | 'sexual_health' | 'nootropic' | 'ldn' | 'sterile' | 'anti_aging' | 'topical_anesthetic' | 'vitamin_replacement'
export type FormEnum = 'injection' | 'capsule' | 'cream' | 'troche' | 'nasal_spray' | 'tablet' | 'mini_troche' | 'drops' | 'solution' | 'triturate'
export type RouteEnum = 'oral' | 'topical' | 'injection' | 'nasal_spray' | 'suppository'
export type UnitEnum = 'mL' | 'mg' | 'count'
export type RateEnum = 'mL' | 'mg'

// Types matching the new OpenAPI schema
export interface FormularyIngredient {
  medication_id: string
  dose: number
  dose_unit: UnitEnum
  priority: number
}

export interface FormularyFormula {
  rate: number
  rate_unit: RateEnum
  ingredients: FormularyIngredient[]
}

export interface FormularyPricing {
  pharmacy: string
  price: number
}

export interface FormularyPharmacy {
  id: string
  href: string
  name: string
  available: boolean
  price: number
  shipping?: string[]
}

// Formulary list item (simplified for lists)
export interface FormularyListItem {
  id: string
  href: string
  name: string
  description?: string
  category: CategoryEnum
  form: FormEnum
  route: RouteEnum
  pricing: FormularyPricing[]
}

// Detailed formulary item (for individual views)
export interface FormularyItem {
  id: string
  href: string
  name: string
  description?: string
  dose: number
  dose_unit: UnitEnum
  package_count: number
  package_unit: UnitEnum
  category: CategoryEnum
  form: FormEnum
  route: RouteEnum
  formula: FormularyFormula[]
  pharmacies?: FormularyPharmacy[]
}

export interface FormularyListResponse {
  page_size: number
  page_number: number
  page_previous: string | null
  page_next: string | null
  total_items: number
  href: string
  items: FormularyListItem[]
}

export interface FormularyQueryParams {
  category?: CategoryEnum[]
  form?: FormEnum[]
  route?: RouteEnum[]
  pharmacy?: string[]
  page_size?: number
  page_number?: number
  name?: string[]
}

export const formularyApi = {
  // HATEOAS-style: Use the href from clinic.formulary.href
  async getFormulary(formularyHref: string, params?: FormularyQueryParams): Promise<FormularyListResponse> {
    let finalUrl = formularyHref
    
    // If this is already a complete HATEOAS URL (contains query params), use it directly
    if (formularyHref.includes('?')) {
      console.log('HATEOAS: Using complete formulary pagination URL:', formularyHref)
      finalUrl = formularyHref
    } else {
      // Build query params if provided and this is a base href
      let queryString = ''
      if (params) {
        const searchParams = new URLSearchParams()
        if (params.category) params.category.forEach(c => searchParams.append('category', c))
        if (params.form) params.form.forEach(f => searchParams.append('form', f))
        if (params.route) params.route.forEach(r => searchParams.append('route', r))
        if (params.pharmacy) params.pharmacy.forEach(p => searchParams.append('pharmacy', p))
        if (params.name) params.name.forEach(n => searchParams.append('name', n))
        if (params.page_size) searchParams.set('page_size', params.page_size.toString())
        if (params.page_number) searchParams.set('page_number', params.page_number.toString())
        queryString = searchParams.toString() ? `?${searchParams.toString()}` : ''
      }
      finalUrl = `${formularyHref}${queryString}`
    }
    
    const data = await apiCall(finalUrl)
    console.log('API returned data:', data)
    
    return data as FormularyListResponse
  },

  // HATEOAS-style: Get individual formulary item details
  async getFormularyItem(itemHref: string): Promise<FormularyItem> {
    const data = await apiCall(itemHref)
    return data as FormularyItem
  }
}